export default {
  address: "桃園市龜山區文桃路與樂善一路口",
  googleSrc:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.5928786474415!2d121.3877746!3d25.0478868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDAyJzUyLjQiTiAxMjHCsDIzJzE2LjAiRQ!5e0!3m2!1szh-TW!2stw!4v1614266126683!5m2!1szh-TW!2stw",
  googleLink: "https://goo.gl/maps/e6zuP3sw2EQSuNSp6",
  phone: "03-388-3888",
  fbLink:
    "https://www.facebook.com/%E6%96%87%E8%8F%AF%E5%A4%A9%E9%9A%9B-191595829072462",
  fbMessage: "https://m.me/191595829072462/",
  caseName: "文華天際",
  indigatorLength: 10,

  houseInfos: [
    ["投資新建", "合遠建設股份有限公司"],
    ["營造公司", "國城營造有限公司"],
    ["建築設計", "蔡智勸建築師事務所"],
    ["企劃銷售", "新誠家廣告有限公司"],
    ["接待中心", "桃園市龜山區文桃路與樂善一路口"]
  ],

  gtmCode: ["P89J73T","K9KV49N"], // 可放置多個
  recaptcha_site_key_v2: "6Lep-78UAAAAAMaZLtddpvpixEb8cqu7v7758gLz",
  recaptcha_site_key: "6Lck-L8UAAAAABxfvNA1NJuBrdl3iLFc3GkudC8s", // recaptcha v3
  recaptcha_user_token: "6Lck-L8UAAAAAIcvenwGDl8_Q1tKbrEYsKuriePa",
  order: {
    title: "預約專線",
    subTitle: "｜預約賞屋表單｜"
  }
};
